export default __webpack_public_path__ + "static/media/test.e954b41f.png";